<template>
    <div id="RefundReviewProgress">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click.native="goBack()"/>
            </div>
            <div slot="title">审核进度</div>
        </nav-bar>
        <div class="refund-order-num">
            <div>
                <p>服务单号：198014266</p>
                <p>申请时间：2017-05-01 16:00</p>
            </div>
        </div>
        <div class="review-reply">
            <div>
                您的售后服务单已完成，感谢您的支持和理解！
            </div>
        </div>
        <div class="problem-desc">
            <div class="problem-title">
                <span>进度跟踪</span>
            </div>
            <div class="problem-detail">
                <van-steps :active="active" active-color="#6698cb" direction="vertical">
                    <van-step>
                        <p>您的服务单财务已退款，请您注意查收</p>
                        <p>经办人：laijiarong</p>
                        <p>2016-07-20 12:40:25</p>
                    </van-step>
                    <van-step>
                        <p>您的服务单退款申请业务主管已审核，等待财务确认</p>
                        <p>经办人：laijiarong</p>
                        <p>2016-07-19 12:40:25</p>
                    </van-step>
                    <van-step>
                        <p>您的服务单已提交退款申请</p>
                        <p>经办人：laijiarong</p>
                        <p>2016-07-18 12:40:25</p>
                    </van-step>
                    <van-step>
                        <p>您的服务单198014266的商品已收到</p>
                        <p>经办人：huangqing23</p>
                        <p>2016-07-17 12:40:25</p>
                    </van-step>
                    <van-step>
                        <p>您的服务单已审核通过，请将商品寄往售后部</p>
                        <p>经办人：李颖</p>
                        <p>2016-07-13 12:40:25</p>
                    </van-step>
                    <van-step>
                        <p>您的服务单已申请成功，待售后审核中</p>
                        <p>经办人：系统</p>
                        <p>2016-07-12 12:40:25</p>
                    </van-step>
                </van-steps>
            </div>
        </div>
    </div>
</template>

<script>
    import {Icon,Toast, Steps, Step} from 'vant';
    import NavBar from "@/components/common/navbar/NavBar";
    export default {
        name: "RefundReviewProgress",
        data(){
          return {
              active: 0,
          }
        },
        components: {
            NavBar: NavBar,
            [Icon.name]: Icon,
            [Steps.name]: Steps,
            [Step.name]: Step
        },
        methods: {
            goBack() {
                this.$router.back(-1);
            },
        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";

    .van-nav-bar {
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, .5);
        background-color: #efefef;
        z-index: 100;
    }

    .refund-order-num {
        margin-top: 46px;
        height: 90px;
        background-color: #ffffff;
    }

    .refund-order-num div {
        padding: 3px 20px;
        font-size: 15px;
        color: #666666;
    }

    .review-reply {
        margin-top: 20px;
        background-color: #ffffff;
    }

    .review-reply div {
        padding: 10px 20px;
        color: #999999;
    }
    .problem-desc {
        background-color: #ffffff;
        margin-top: 20px;
    }

    .problem-title {
        height: 45px;
        color: #666666;
        line-height: 45px;
        border-bottom: solid 0.5px #cccccc;
        padding-left: 20px;
    }

    .problem-detail {
        color: #666666;
        height: 100%;
    }

    .van-step--finish {
        color: #6698cb;
    }


</style>